import React from 'react';
import { Divider, Input } from 'antd';
// import { CameraOutlined, UserOutlined } from '@ant-design/icons';
import { Form } from '..';
import Wrapper from './style';

const Index = () => {
  return (
    <Wrapper>
      <Divider />
      <div className="black1 font-subtitle2_medium">
        Social Details (Optional)
      </div>
      <div className="component_social_details_forms">
        <Form.Item name="ig_username" label="Instagram">
          <Input placeholder="instagram" />
        </Form.Item>
        <Form.Item name="fb_username" label="Facebook">
          <Input placeholder="Facebook" />
        </Form.Item>
        <Form.Item name="linkedin_username" label="Linkedin">
          <Input placeholder="Linkedin" />
        </Form.Item>
        <Form.Item name="twt_username" label="Twitter">
          <Input placeholder="twitter" />
        </Form.Item>
      </div>
    </Wrapper>
  );
};

export default Index;
